module.exports = __webpack_public_path__ + "img/null.85240fa.png";